import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import CompanyIntro from './components/CompanyIntro';
import TeamSection from './components/TeamSection';
import PartnersSection from './components/PartnersSection';
import ComputeClusterSection from './components/ComputeClusterSection';

const AboutPage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <AboutHero />
        <CompanyIntro />
        <TeamSection />
        <ComputeClusterSection />
        <PartnersSection />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
